import { SELECTORS } from '$utils/constants';
import type { FilterOptions } from '$utils/types';

import { displayElement } from './displayElement';
import { getLocation } from './location';
const findSuccess = document.querySelector(SELECTORS.findSuccess) as HTMLElement;
const noRecords = document.querySelector(SELECTORS.noRecords) as HTMLElement;
const internalError = document.querySelector(SELECTORS.internalError) as HTMLElement;
const loader = document.querySelector(SELECTORS.loader) as HTMLElement;
export const findProfiles = async (filters: any) => {
  try {
    displayElement(loader, true);
    const response = await fetch(
      'https://insightiqapi.netlify.app/.netlify/functions/getProfiles',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(filters),
      }
    );

    const data = await response.json();
    displayElement(loader, false);
    displayElement(findSuccess, false);
    displayElement(noRecords, false);
    displayElement(internalError, false);

    // results less than 5
    if (data.metadata.total_results < 1) {
      displayElement(noRecords, true);
      return undefined;
    }

    // successfull results
    if (!data.error) {
      getLocation();
      displayElement(findSuccess, true);
      return data;
    }

    // no records found
    if (data.error.type === 'RECORD_NOT_FOUND') {
      displayElement(noRecords, true);
      return undefined;
    }
    // internal error
    if (data.error) {
      displayElement(internalError, true);
      displayElement(loader, false);
      displayElement(findSuccess, false);
      return undefined;
    }
  } catch (error) {
    // internal error
    displayElement(internalError, true);
    displayElement(loader, false);
    displayElement(findSuccess, false);
    console.error('Error HERE:', error);
    return undefined;
  }
};
